"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _path = _interopRequireDefault(require("../../helpers/path"));
require("./VerificationRequiredComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VerificationRequiredComponent = function VerificationRequiredComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var customClass = props.customClass,
    className = props.className,
    disabled = props.disabled,
    isUnderReview = props.isUnderReview,
    verificationLevelPageUrl = props.verificationLevelPageUrl,
    enableOnClick = props.enableOnClick,
    onVerificationLinkClick = props.onVerificationLinkClick,
    _onClick = props.onClick,
    customKYCmessage = props.customKYCmessage,
    history = props.history,
    disableKYCLinkUnderReview = props.disableKYCLinkUnderReview;
  var noLink = disableKYCLinkUnderReview ? isUnderReview : verificationLevelPageUrl === '';
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['verification-required', customClass]);
  var handleOnVerificationLinkClick = function handleOnVerificationLinkClick() {
    if (verificationLevelPageUrl.match(/^http/)) {
      window.location.href = verificationLevelPageUrl;
    } else {
      history.push((0, _path["default"])(verificationLevelPageUrl));
      if (enableOnClick) onVerificationLinkClick();
    }
  };
  if (disabled) return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(noLink ? 'no-link' : ''),
    onClick: function onClick() {
      if (noLink) return;
      handleOnVerificationLinkClick();
      _onClick && _onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "alert",
    customClass: bemClasses('warning'),
    classModifiers: "small"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap--label ".concat(bemClasses('not-verified'), " ").concat(className)
  }, customKYCmessage ? customKYCmessage : getVerificationRequiredMessage(t, isUnderReview, noLink)))));
  return null;
};
var getVerificationRequiredMessage = function getVerificationRequiredMessage(t, isUnderReview, noLink) {
  if (noLink && isUnderReview) return t('You are not yet verified. Verification under review.');else if (noLink) return t('You are not yet verified. Verify your identity to start trading.');else if (isUnderReview) return t('Verification under review. Click here to check your verification status.');else return t('Verify your identity to start trading. Click here to verify.');
};
VerificationRequiredComponent.defaultProps = {
  className: '',
  onVerificationLinkClick: function onVerificationLinkClick() {},
  isUnderReview: false,
  disabled: false,
  enableOnClick: true,
  disableKYCLinkUnderReview: false
};
VerificationRequiredComponent.propTypes = {
  className: _propTypes["default"].string,
  verificationLevelPageUrl: _propTypes["default"].string.isRequired,
  onVerificationLinkClick: _propTypes["default"].func.isRequired,
  isUnderReview: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool,
  enableOnClick: _propTypes["default"].bool,
  customKYCmessage: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactRouterDom.withRouter)(VerificationRequiredComponent);